import styled, { withTheme } from 'styled-components';
import { Tab as MuiTab } from '@material-ui/core';

const BlockTabLoadable = styled(MuiTab)`
  text-transform: none;
  opacity: 0;
  transition: opacity 0.75s ease-in;

  &.loaded {
    opacity: 1;
  }
  ${(props) => props.theme.breakpoints.up('md')} {
    text-transform: uppercase;
    padding: 16px 8px;
    margin: 0 5px 0 0;

    &:last-child {
      margin-right: 0;
    }
    color: ${(props) => props.theme.palette.common.coral};

    &.MuiTab-textColorPrimary.Mui-selected {
      color: ${(props) =>
        props.theme.palette.type === 'dark'
          ? props.theme.palette.common.tan
          : props.theme.palette.common.midBlue};
      background: ${(props) =>
        props.theme.palette.type === 'dark'
          ? props.theme.palette.common.backgroundMuted
          : props.theme.palette.common.white};
      outline: none;
    }
  }
`;

export default withTheme(BlockTabLoadable);
